module.exports = __webpack_public_path__ + "img/29.839c99d6.png";